/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { useControlled } from '../../../../internal/hooks';
export function useOpenCloseControlled(props) {
  const {
    onOpen,
    onClose
  } = props;
  const [open, setOpen] = useControlled({
    controlled: props.open,
    default: false
  });
  const handleOpen = React.useCallback(() => {
    setOpen(true);
    if (onOpen) {
      onOpen();
    }
  }, [onOpen, setOpen]);
  const handleClose = React.useCallback(() => {
    setOpen(false);
    if (onClose) {
      onClose();
    }
  }, [onClose, setOpen]);
  return {
    open,
    handleClose,
    handleOpen
  };
}